import { Icon, Spinner, TextField } from "@fluentui/react";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { FieldErrors, FieldValues, UseFormSetValue } from "react-hook-form";

export interface IcustomTextFilEmp {
  placeholder:string;
  label:string;
  type:string;
  width:string;
  height:string;
  name:string;
  setValue: UseFormSetValue<FieldValues>;
  value?:string;
  disabled?:boolean;
  errors: FieldErrors<FieldValues>;
  errormessage?: string;
  paddingLeft?:string;
  errorpattern?:string;
  errorvalidate?:string;
} 

export function CustomTextFilEmpesas ({
    placeholder,label,type,width,height,name,setValue,
    value=undefined,disabled=false,errors,
    errormessage=t('El campo no puede ser vacío'),
    paddingLeft='230px',
    errorpattern=t('error tipo pattern'),
    errorvalidate = t('error tipo validate')
  }:IcustomTextFilEmp){
    const [selectedKey, setSelectedKey] = useState<string | undefined>(undefined);
    const handlerhange = (name:string,text:string | undefined)=>{
      setValue(name,text);
      setSelectedKey(text);
    }
    useEffect(()=>{
      if(value){
        handlerhange(name,value);
      }
    },[value,errors]);
    return(
      <span className="input_reusable">
        <TextField
          styles={{root:{width:width, height:height}}}
          placeholder={placeholder}
          label={label}
          type={type}
          onChange={(_,text)=>handlerhange(name,text)}
          value={selectedKey}
          disabled={disabled}
          key={name + placeholder + label}
        />
    {/* {disabled && <Spinner styles={{root:{marginTop:'20px',paddingLeft:paddingLeft,marginBottom:'-40px'}}} />} */}
    {errors[name]?.type === 'required' && 
    <span className='style-message-custom-text'>
        {errormessage}
    </span>}
    {errors[name]?.type === 'pattern' && 
    <span className='style-message-custom-text'>
        {errorpattern}
    </span>}
    {errors[name]?.type === 'validate' && 
    <span className='style-message-custom-text'>
        {errorvalidate}
    </span>}
      </span>
    )
  }

  //modal de confirmacion
  type ModalProps = {
    title?: string;
    message?: string;
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
  };
  
  export const ModalConfirm: React.FC<ModalProps> = ({ isOpen, onClose, onConfirm,title,message }) => {
    if (!isOpen) return null;
  
    return (
      <div className="Customodal-overlay">
        <div className="Customodal"  style={{width:'280px'}}>
          <div className="Customodal-header">
            <Icon iconName='IncidentTriangle' style={{fontSize:"25px",color:"#ffd966"}} />
            <h2> {title} </h2>
          </div>
          <div className="Customodal-body">
            <p> {message} </p>
          </div>
          <div className="Customodal-footer">
            <button className="Custobtn-confirm" onClick={onConfirm}>{t('Si')}</button>
            <button className="Custobtn-cancel" onClick={onClose}>{t('Cancelar')}</button>
          </div>
        </div>
      </div>
    );
  }; 